/**
 * Ohio sales tax rates by county.
 *
 * SOURCE OF TRUTH: Ohio Department of Taxation official sales tax rate map
 * https://dam.assets.ohio.gov/image/upload/tax.ohio.gov/tax_analysis/tax_data_series/sales_and_use/Salestaxmap.pdf
 *
 * Last synced: Oct 2025 effective date. Rates stored as decimals (0.0725 = 7.25%).
 * Rebuilt from the official state PDF — DO NOT hand-edit individual rates.
 * When the state publishes a new effective-date map, re-extract and replace
 * the array in one shot to keep the audit trail clean.
 *
 * Customer-facing copy still calls this a GUESSTIMATE and links to the
 * official PDF for verification.
 */
export const OHIO_TAX_EFFECTIVE_DATE = "October 2025";

export const OHIO_COUNTIES = [
  { name: "Adams",      rate: 0.0725 },
  { name: "Allen",      rate: 0.0685 },
  { name: "Ashland",    rate: 0.0700 },
  { name: "Ashtabula",  rate: 0.0675 },
  { name: "Athens",     rate: 0.0725 },
  { name: "Auglaize",   rate: 0.0725 },
  { name: "Belmont",    rate: 0.0725 },
  { name: "Brown",      rate: 0.0700 },
  { name: "Butler",     rate: 0.0650 },
  { name: "Carroll",    rate: 0.0675 },
  { name: "Champaign",  rate: 0.0725 },
  { name: "Clark",      rate: 0.0725 },
  { name: "Clermont",   rate: 0.0675 },
  { name: "Clinton",    rate: 0.0725 },
  { name: "Columbiana", rate: 0.0725 },
  { name: "Coshocton",  rate: 0.0775 },
  { name: "Crawford",   rate: 0.0725 },
  { name: "Cuyahoga",   rate: 0.0800 },
  { name: "Darke",      rate: 0.0725 },
  { name: "Defiance",   rate: 0.0675 },
  { name: "Delaware",   rate: 0.0700 },
  { name: "Erie",       rate: 0.0675 },
  { name: "Fairfield",  rate: 0.0675 },
  { name: "Fayette",    rate: 0.0725 },
  { name: "Franklin",   rate: 0.0800 },
  { name: "Fulton",     rate: 0.0725 },
  { name: "Gallia",     rate: 0.0725 },
  { name: "Geauga",     rate: 0.0675 },
  { name: "Greene",     rate: 0.0675 },
  { name: "Guernsey",   rate: 0.0725 },
  { name: "Hamilton",   rate: 0.0780 },
  { name: "Hancock",    rate: 0.0675 },
  { name: "Hardin",     rate: 0.0725 },
  { name: "Harrison",   rate: 0.0725 },
  { name: "Henry",      rate: 0.0725 },
  { name: "Highland",   rate: 0.0725 },
  { name: "Hocking",    rate: 0.0725 },
  { name: "Holmes",     rate: 0.0700 },
  { name: "Huron",      rate: 0.0725 },
  { name: "Jackson",    rate: 0.0725 },
  { name: "Jefferson",  rate: 0.0725 },
  { name: "Knox",       rate: 0.0725 },
  { name: "Lake",       rate: 0.0725 },
  { name: "Lawrence",   rate: 0.0725 },
  { name: "Licking",    rate: 0.0725 },
  { name: "Logan",      rate: 0.0725 },
  { name: "Lorain",     rate: 0.0650 },
  { name: "Lucas",      rate: 0.0775 },
  { name: "Madison",    rate: 0.0700 },
  { name: "Mahoning",   rate: 0.0750 },
  { name: "Marion",     rate: 0.0725 },
  { name: "Medina",     rate: 0.0675 },
  { name: "Meigs",      rate: 0.0725 },
  { name: "Mercer",     rate: 0.0725 },
  { name: "Miami",      rate: 0.0700 },
  { name: "Monroe",     rate: 0.0725 },
  { name: "Montgomery", rate: 0.0750 },
  { name: "Morgan",     rate: 0.0725 },
  { name: "Morrow",     rate: 0.0725 },
  { name: "Muskingum",  rate: 0.0725 },
  { name: "Noble",      rate: 0.0725 },
  { name: "Ottawa",     rate: 0.0700 },
  { name: "Paulding",   rate: 0.0725 },
  { name: "Perry",      rate: 0.0725 },
  { name: "Pickaway",   rate: 0.0725 },
  { name: "Pike",       rate: 0.0725 },
  { name: "Portage",    rate: 0.0700 },
  { name: "Preble",     rate: 0.0725 },
  { name: "Putnam",     rate: 0.0700 },
  { name: "Richland",   rate: 0.0700 },
  { name: "Ross",       rate: 0.0725 },
  { name: "Sandusky",   rate: 0.0725 },
  { name: "Scioto",     rate: 0.0725 },
  { name: "Seneca",     rate: 0.0725 },
  { name: "Shelby",     rate: 0.0725 },
  { name: "Stark",      rate: 0.0650 },
  { name: "Summit",     rate: 0.0675 },
  { name: "Trumbull",   rate: 0.0675 },
  { name: "Tuscarawas", rate: 0.0675 },
  { name: "Union",      rate: 0.0700 },
  { name: "Van Wert",   rate: 0.0725 },
  { name: "Vinton",     rate: 0.0725 },
  { name: "Warren",     rate: 0.0675 },
  { name: "Washington", rate: 0.0725 },
  { name: "Wayne",      rate: 0.0650 },
  { name: "Williams",   rate: 0.0725 },
  { name: "Wood",       rate: 0.0675 },
  { name: "Wyandot",    rate: 0.0725 },
];

export const OHIO_TAX_PDF =
  "https://dam.assets.ohio.gov/image/upload/tax.ohio.gov/tax_analysis/tax_data_series/sales_and_use/Salestaxmap.pdf";

// ---------------- Credit tier rate ceilings ----------------
// We use these internally to compute estimated payments. We DO NOT show the
// actual rate to the customer — only a disclosure that the number is a
// guesstimate based on national averages. Rate is hard-capped at 24.99%.
export const CREDIT_TIERS = [
  { value: "perfect", label: "Perfect (781 – 850)",       new: 0.0650, used: 0.0850 },
  { value: "good",    label: "Good (661 – 780)",          new: 0.0800, used: 0.1150 },
  { value: "ok",      label: "OK / Fair (601 – 660)",     new: 0.1400, used: 0.1750 },
  { value: "bad",     label: "Bad (Below 600)",           new: 0.2125, used: 0.2350 }, // midpoints of the published ranges
];

export const RATE_CEILING = 0.2499;

// ---------------- Dealer fees (v6.5.1 — split out per Ohio spec) ----------------
export const FEE_DOC = 398;     // dealership documentation fee
export const FEE_STATE = 18;    // state of Ohio fee
export const FEE_TITLE = 50;    // title fee
export const FEE_TEMP_TAG = 23; // optional temporary tag (checkbox)
// Legacy aliases kept for backwards-compat with older callers
export const FEE_GOV = FEE_STATE + FEE_TITLE; // legacy = state + title
export const PROTECTION_STANDARD = 954;
export const PROTECTION_DISCOUNT = 754;

/**
 * Compute the Ohio sales tax for a vehicle purchase.
 * v6.5.1 Ohio rule: rebates and cash down are TAXABLE. They do NOT reduce the
 * taxable amount. Only an eligible new-vehicle trade allowance reduces it.
 *
 *   taxable = max(0, selling_price - eligible_trade_allowance)
 */
export function computeOhioTax({ price = 0, tradeValue = 0, rebates = 0, rate = 0.0725 }) {
  // `rebates` argument intentionally ignored — kept for back-compat.
  void rebates;
  const base = Math.max(0, (price || 0) - (tradeValue || 0));
  return Math.max(0, base * rate);
}

/**
 * Standard amortization formula.
 *   m = P * (r / (1 - (1 + r) ** -n))
 * where r is monthly rate and n is term in months.
 */
export function computeMonthlyPayment({ amountFinanced, annualRate, months }) {
  const principal = Math.max(0, amountFinanced || 0);
  const r = Math.min(annualRate || 0, RATE_CEILING) / 12;
  const n = Math.max(1, Math.round(months || 0));
  if (principal === 0) return 0;
  if (r === 0) return principal / n;
  return principal * (r / (1 - Math.pow(1 + r, -n)));
}
